import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { IsPriceVisible, SumInButtonChangeTypeOfWarehouse, TwoTypesOfOfferHandler } from "../../helpers/types";
import { DedicateWarehouse } from "./dedicated-warehouse";
import { MultiWarehouse } from "./multi-warehouse";

interface TyperOfOfferProps {
    type_of_offer: number,
    isPriceVisible: IsPriceVisible,
    isMultiWarehouseDisable: boolean,
    isDedicateWarehouseDisable: boolean;
    //isThePriceVisibleInMultiWarehouseButton: boolean,
    //isComponentNoMatchingWarehousesVisible: boolean;
    value_dedicate_warehouse: SumInButtonChangeTypeOfWarehouse | undefined,
    value_multi_warehouse: SumInButtonChangeTypeOfWarehouse | undefined,
    isTwoTypesOfOffer: TwoTypesOfOfferHandler,
    handleClik: (value: number) => void,
}

export const TyperOfOffer = ({
    type_of_offer,
    isPriceVisible,
    isMultiWarehouseDisable,
    isDedicateWarehouseDisable,
    value_dedicate_warehouse,
    value_multi_warehouse,
    isTwoTypesOfOffer,
    handleClik
}: TyperOfOfferProps) => {
    return (
        <Container>
            <MultiWarehouse
                isPriceVisible={isPriceVisible}
                isMultiWarehouseDisable={isMultiWarehouseDisable}
                isActive={type_of_offer === 1 ? true : false}
                min_value={value_multi_warehouse?.min_value ? value_multi_warehouse?.min_value : -1}
                max_value={value_multi_warehouse?.max_value ? value_multi_warehouse?.max_value : -1}
                requires_consultation={value_multi_warehouse?.requires_consultation
                    ? value_multi_warehouse?.requires_consultation
                    : false}
                isTwoTypesOfOffer={isTwoTypesOfOffer}
                handleClik={handleClik}

            />
            <DedicateWarehouse
                isPriceVisible={isPriceVisible}
                isDedicateWarehouseDisable={isDedicateWarehouseDisable}
                isActive={type_of_offer === 0 ? true : false}
                min_value={value_dedicate_warehouse?.min_value ? value_dedicate_warehouse?.min_value : -1}
                max_value={value_dedicate_warehouse?.max_value ? value_dedicate_warehouse?.max_value : -1}
                requires_consultation={value_dedicate_warehouse?.requires_consultation
                    ? value_dedicate_warehouse?.requires_consultation
                    : false}
                isTwoTypesOfOffer={isTwoTypesOfOffer}
                handleClik={handleClik}
            />
        </Container>
    );
};

const Container = styled.div`
display:flex;
flex-direction: row;
align-items:center;
justify-content: space-between;
width:100%;
align-items: stretch;
margin-bottom:24px;
//gap:20px;
@media (max-width:560px){
    flex-direction: column; 
    justify-content: center;
    justify-content: center;
    margin: auto;
    width: auto;
    row-gap: 10px;
    margin-bottom:24px;
}
`;